import React from "react";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import Strings from "../../utils/Strings";
import { privacy } from "./Details";
import Footer from "../Footer/Footer";

const Privacy = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-gray-50">
      <div className="font-jost mb-4 min-h-screen w-full ">
      <div className="mx-auto flex w-[90%] flex-col gap-5 p-5 text-justify pt-24">
      <div
        onClick={() => navigate(-1)}
        className="font-jost hidden w-fit cursor-pointer items-center gap-2 overflow-hidden rounded-full bg-textYellowLight px-4 py-2 shadow-md transition-all hover:bg-yellow-300 active:scale-95 md:flex"
      >
        <IoMdArrowBack className="h-6 w-6 text-gray-800" />
        <p className="whitespace-nowrap text-center text-sm text-gray-900 md:text-base">
          Go Back
        </p>
      </div>
      <div className="p-5 bg-white shadow-lg rounded-xl">
      <div>
          <h1 className="p-2 text-4xl text-center">
            {Strings.PRIVACY_HEADER}{" "}
          </h1>
          {/* <p className="text-md p-3 ">{Strings.PRIVACY_TEXT}</p> */}
        </div>
        {privacy.map((privacy, index) => {
          return (
            <div className="flex flex-col gap-2 p-2" key={index}>
              <h1 className="font-semibold underline ">{privacy.Title}</h1>
              <p className="text-md">{privacy.Content}</p>
              <p className="text-md">{privacy.Content1}</p>
              <p className="text-md">{privacy.Content2}</p>
              <p className="text-md">{privacy.Content3}</p>
              <p className="text-md">{privacy.Content4}</p>
            </div>
          );
        })}
      </div>
       
      </div>
    </div>
    <Footer/>
    </div>
    
  );
};

export default Privacy;
